import { forwardRef, ReactElement, ReactNode } from 'react'
import Save from '@mui/icons-material/Save'
import { LoadingButton, LoadingButtonProps } from '@mui/lab'

interface Props extends LoadingButtonProps {
  children: ReactNode
}

const SaveButton = forwardRef<HTMLButtonElement, Props>(
  ({ children, ...props }, ref): ReactElement => (
    <LoadingButton {...props} ref={ref} variant="contained" color="primary" startIcon={<Save />}>
      {children}
    </LoadingButton>
  ),
)

SaveButton.displayName = 'SaveButton'

export default SaveButton
